module.exports = "/assets/information.svg";